<div class="no-processes"
    *appShowAuthorize="'APP_FILE_PROCESS_WRITE'; options: { values: { customerSpaceId: customerSpaceId, processType: processType } }">

    <a class="primary-link" *ngIf="(cockpitProcess$ | async)!.length === 0" [routerLink]="createEntityLink">
        <mat-icon *ngIf="legalEntities.length === 0 || legalEntities.length > 1" fontSet="mdi"
            fontIcon="{{ legalEntities.length === 0 ? 'mdi-plus-circle-outline' : 'mdi-open-in-new' }}" class="add-icon"
            color="primary"></mat-icon>
        <ng-container *ngIf="legalEntities.length === 0">
            {{ 'FILE-PROCESS.legal-entity-list.create-legal-entity' | translate }}
        </ng-container>
        <ng-container *ngIf="legalEntities.length > 1">
            <span>{{ 'FILE-PROCESS.legal-entity-list.navigate-to' | translate
                }}</span>
        </ng-container>
    </a>
    <ng-container *ngIf="(cockpitProcess$ | async)!.length === 0 && legalEntities.length === 1">
        <div class="legal-entity-name">
            <a class="primary-link" [routerLink]="[
          '/customer-spaces',
          customerSpaceId,
          'file-process',
          processType,
          'legal-entities',
          legalEntities[0].id,
          'processes'
        ]">
                {{ legalEntities[0].name | shorten }}
            </a>
        </div>
        <div class="process-name">
            <a class="primary-link link-holder" [routerLink]="[
          '/customer-spaces',
          customerSpaceId,
          'file-process',
          processType,
          'legal-entities',
          legalEntities[0].id,
          'processes',
          'create'
        ]">
                <mat-icon svgIcon="add_icon"></mat-icon>
                {{ 'FILE-PROCESS.process-list.' + processType + '.create' | translate }}
            </a>
        </div>
    </ng-container>
</div>